import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { consumerApi } from '../lib/consumer-api/consumer-api'
import { SIMULATOR_KEY, simulatorSlice } from '../lib/simulator/simulator.slice'

declare const process: any

const reducers = combineReducers({
  // Add the generated reducer as a specific top-level slice
  [consumerApi.reducerPath]: consumerApi.reducer,
  [SIMULATOR_KEY]: simulatorSlice.reducer,
})

const devTools = process.env.NODE_ENV === 'development'

const middlewares = [consumerApi.middleware]

// eslint-disable-next-line no-underscore-dangle
if (!process.env.JEST_WORKER_ID && __DEV__) {
  // eslint-disable-next-line global-require
  const reduxDebugger = require('redux-middleware-flipper').default
  middlewares.push(reduxDebugger({ actionsBlacklist: [] }))
}

export const makeStore = () =>
  configureStore({
    reducer: reducers,
    devTools,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(middlewares),
  })

export const makeTestStore = (preloadedState?: any) =>
  configureStore({
    reducer: reducers,
    devTools,
    preloadedState,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  })
